import { render, staticRenderFns } from "./UserSet.vue?vue&type=template&id=38853c82&scoped=true"
import script from "./UserSet.vue?vue&type=script&lang=js"
export * from "./UserSet.vue?vue&type=script&lang=js"
import style0 from "./UserSet.vue?vue&type=style&index=0&id=38853c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38853c82",
  null
  
)

export default component.exports